import React, { useMemo } from 'react';
import { subDays, parseISO } from 'date-fns';

export default function QuickStats({ checkIns }) {
  const stats = useMemo(() => {
    const now = new Date();
    const thisWeek = checkIns.filter(c => parseISO(c.checkInDate) >= subDays(now, 7));
    const lastWeek = checkIns.filter(c => {
      const d = parseISO(c.checkInDate);
      return d >= subDays(now, 14) && d < subDays(now, 7);
    });

    const avg = (arr, field) => {
      const vals = arr.filter(c => c[field] != null).map(c => c[field]);
      return vals.length ? (vals.reduce((a, b) => a + b, 0) / vals.length) : null;
    };

    const thisWeekPain = avg(thisWeek, 'painLevel');
    const lastWeekPain = avg(lastWeek, 'painLevel');
    const flareDays = thisWeek.filter(c => c.isFlareDay).length;
    const totalCheckIns = checkIns.length;

    return { thisWeekPain, lastWeekPain, flareDays, totalCheckIns };
  }, [checkIns]);

  const painTrend = stats.thisWeekPain != null && stats.lastWeekPain != null
    ? stats.thisWeekPain - stats.lastWeekPain
    : null;

  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
      <StatCard
        label="Avg Pain (7d)"
        value={stats.thisWeekPain != null ? stats.thisWeekPain.toFixed(1) : '-'}
        subtext={painTrend != null ? (painTrend > 0 ? `+${painTrend.toFixed(1)} vs last week` : `${painTrend.toFixed(1)} vs last week`) : null}
        subtextColor={painTrend != null ? (painTrend > 0 ? 'text-white/70' : 'text-white/70') : 'text-white/50'}
      />
      <StatCard
        label="Flare Days (7d)"
        value={stats.flareDays}
        subtext="this week"
      />
      <StatCard
        label="Check-ins"
        value={stats.totalCheckIns}
        subtext="total logged"
      />
      <StatCard
        label="Streak"
        value={calculateStreak(checkIns)}
        subtext="days in a row"
      />
    </div>
  );
}

function StatCard({ label, value, subtext, subtextColor = 'text-white/50' }) {
  return (
    <div className="glass rounded-xl p-4">
      <p className="text-xs font-medium text-white/60 uppercase tracking-wide">{label}</p>
      <p className="text-2xl font-bold text-white mt-1">{value}</p>
      {subtext && <p className={`text-xs mt-1 ${subtextColor}`}>{subtext}</p>}
    </div>
  );
}

function calculateStreak(checkIns) {
  if (!checkIns.length) return 0;

  const dates = [...new Set(checkIns.map(c => c.checkInDate))].sort().reverse();
  let streak = 0;
  let current = new Date();

  for (const dateStr of dates) {
    const date = parseISO(dateStr);
    const diff = Math.round((current - date) / (1000 * 60 * 60 * 24));
    if (diff <= 1) {
      streak++;
      current = date;
    } else {
      break;
    }
  }

  return streak;
}
